import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getVendors = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/vendors';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const vendorAPI = {
    getVendors
}

export default vendorAPI
